<template>
  <div class="sidebar">
    <slot>Sidebar</slot>
  </div>
</template>
<script>
import { sidebarCssClasses } from '../../shared/classes'
import toggleClasses from '../../shared/toggle-classes'
export default {
  name: 'sidebar',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    },
    display: {
      type: String,
      default: 'lg'
    }
  },
  mounted: function() {
    this.isFixed()
    this.toggle();
  },
  methods: {
    isFixed() {
      this.fixed ? document.body.classList.add('sidebar-fixed') : document.body.classList.remove('sidebar-fixed')
      return this.fixed
    },
    toggle() {
      const [display, mobile] = [this.display, this.mobile]
      let cssClass = sidebarCssClasses[0]
      // cssClass = `sidebar-${display}-show`
      cssClass = 'sidebar-lg-show'
      // toggleClasses(cssClass, sidebarCssClasses)
      document.body.classList.add(cssClass)
    },
  }
}

</script>
<style>
.sidebar .nav-item .fa {
  display: inline;
}

</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue